import React from "react";
import { Pill } from "../../../common/DataList";

// ============================================================
// Cartes à choisir (radios) des modales d'orientation et de modification
// (CE-1370, CE-1414) : légende, aide et erreur lues avec le groupe. Sans
// option, une ligne dit pourquoi (`vide`).
// ============================================================
const ChoixCartes = ({ nom, legende, options, valeur, onChoisir, idAide, aide, idErreur, erreur, refGroupe, vide }) => {
  const decrit = [aide ? idAide : null, erreur ? idErreur : null].filter(Boolean).join(" ");
  return (
    <fieldset className="correction-so__groupe" aria-describedby={decrit || undefined}>
      <legend>
        {legende} <span className="correction-so__requis" aria-hidden="true">*</span>
      </legend>
      {options.length > 0 ? (
        <div className="correction-so__choix" ref={refGroupe}>
          {options.map((option) => (
            <label
              key={option.valeur}
              className={`correction-so__carte${valeur === option.valeur ? " is-checked" : ""}${option.actuel ? " is-disabled" : ""}`}
            >
              <input
                type="radio"
                name={nom}
                value={option.valeur}
                checked={valeur === option.valeur}
                disabled={!!option.actuel}
                onChange={() => onChoisir(option.valeur)}
              />
              <span>
                <span className="correction-so__titre">
                  {option.titre}
                  {option.actuel && <Pill tone="muted">Actuel</Pill>}
                </span>
                <span className="correction-so__description">{option.description}</span>
              </span>
            </label>
          ))}
        </div>
      ) : (
        <p className="orientation-so__attente">{vide}</p>
      )}
      {aide && (
        <p className="correction-so__aide" id={idAide}>
          {aide}
        </p>
      )}
      {erreur && (
        <p className="correction-so__erreur" id={idErreur} role="alert">
          {erreur}
        </p>
      )}
    </fieldset>
  );
};

export default ChoixCartes;
